import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import { useStrategy } from '../../hooks/useStrategy';
import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { useContext, useMemo } from 'react';
import QuickFiltersBooleanValueDisplay from './QuickFiltersBooleanValueDisplay';
import QuickFiltersEnumValueDisplay from './QuickFiltersEnumValueDisplay';
import QuickFiltersDurationValueDisplay from './QuickFiltersDurationValueDisplay';
import QuickFiltersNoValueDisplay from './QuickFiltersNoValueDisplay';
import { Map as ImmutableMap } from 'immutable';
import QuickFiltersNumberValueDisplay from './QuickFiltersNumberValueDisplay';
import QuickFiltersRollingDateValueDisplay from './QuickFiltersRollingDateValueDisplay';
import QuickFiltersStringValueDisplay from './QuickFiltersStringValueDisplay';
import QuickFiltersUnknownValueDisplay from './QuickFiltersUnknownValueDisplay';
import { hasFieldOverrideV2, hasPercentageQuickFilter } from '../../permissions/gates';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import emptyFunction from 'react-utils/emptyFunction';
import QuickFiltersAssociationValueDisplay from './QuickFiltersAssociationValueDisplay';
import { shouldUseEnumComponentsForExternalOptionsField } from '../../utils/externalOptionsConversionUtils';
import { resolveIsUngated } from '../../utils/UserInfoHelper';
import QuickFiltersPercentageValueDisplay from './QuickFiltersPercentageValueDisplay';
import { isRelativeTimeProperty } from '../../utils/isRelativeTimeProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const getValueComponent = (condition, fieldDefinitions, filterFamily, getOperatorsForType) => {
  const field = condition.field;
  if (!field) {
    return undefined;
  }
  const fieldType = fieldDefinitions.getIn([field.name, 'inputType']) || fieldDefinitions.getIn([field.type, 'inputType']) || field.displayType || field.type;
  const displayType = condition.constructor.displayType === DisplayTypes.DefaultDisplayType ? fieldType : condition.constructor.displayType;
  const shouldUseEnumInput = shouldUseEnumComponentsForExternalOptionsField(field, condition, filterFamily, getOperatorsForType, resolveIsUngated());
  if (shouldUseEnumInput && displayType !== DisplayTypes.NoDisplayType) {
    return QuickFiltersEnumValueDisplay;
  }
  if (isRelativeTimeProperty(field)) {
    return QuickFiltersDurationValueDisplay;
  }
  switch (displayType) {
    case DisplayTypes.AssociationDisplayType:
      return QuickFiltersAssociationValueDisplay;
    case DisplayTypes.NoDisplayType:
      if (fieldType === DisplayTypes.BooleanDisplayType) {
        return QuickFiltersUnknownValueDisplay;
      }
      return QuickFiltersNoValueDisplay;
    case DisplayTypes.BooleanDisplayType:
      return QuickFiltersBooleanValueDisplay;
    case DisplayTypes.EnumerationDisplayType:
      return QuickFiltersEnumValueDisplay;
    case DisplayTypes.NumberDisplayType:
      if (field.numberDisplayHint === 'duration') {
        return QuickFiltersDurationValueDisplay;
      }
      if (field.numberDisplayHint === 'percentage' && hasPercentageQuickFilter()) {
        return QuickFiltersPercentageValueDisplay;
      }
      return QuickFiltersNumberValueDisplay;
    case DisplayTypes.StringDisplayType:
      return QuickFiltersStringValueDisplay;
    case DisplayTypes.RollingDateDisplayType:
      return QuickFiltersRollingDateValueDisplay;
    default:
      return undefined;
  }
};
const QuickFiltersValueDisplay = ({
  filterFamily,
  condition,
  onValueDelete = emptyFunction,
  use = QuickFiltersValueDisplayUses.TAGS
}) => {
  const {
    getFieldDefinitions,
    getOperatorsForType
  } = useStrategy();
  const {
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const fieldDefinitions = useMemo(() => {
    if (hasFieldOverrideV2(getIsUngated)) {
      return ImmutableMap();
    }
    return getFieldDefinitions(filterFamily) || ImmutableMap();
  }, [filterFamily, getFieldDefinitions, getIsUngated]);
  const ValueComponent = useMemo(() => getValueComponent(condition, fieldDefinitions, filterFamily, getOperatorsForType), [condition, fieldDefinitions, filterFamily, getOperatorsForType]);
  if (!ValueComponent) {
    return /*#__PURE__*/_jsx("div", {
      children: condition.value.toString()
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ValueComponent, {
      filterFamily: filterFamily
      // @ts-expect-error Type 'OperatorInstance' is not assignable to type 'never'.
      ,
      condition: condition,
      onValueDelete: onValueDelete,
      use: use
    })
  });
};
export default QuickFiltersValueDisplay;